module.exports = __webpack_public_path__ + "static/media/HomeGraphic3.f7e9533e.jpg";